import { render, staticRenderFns } from "./CourseTemplate.vue?vue&type=template&id=278bd024"
import script from "./CourseTemplate.vue?vue&type=script&lang=js"
export * from "./CourseTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports